import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { environment } from '../../../environments/environment';
import { map, mergeMap } from 'rxjs/operators'
import { TranslateService } from '@ngx-translate/core';
import { from, of, Subject } from 'rxjs';

declare var instituicaoConstants: { LINGUAGEM: string; };
@Injectable({ providedIn: 'root' })

export class UserProvider {
  public linguagem: string = instituicaoConstants.LINGUAGEM ? instituicaoConstants.LINGUAGEM : 'pt';
  baseUrl = environment.API_URL;
  baseAntigaUrl = environment.API_ANTIGA_URL;
  idInstituicao = null;
  private messageSource = new Subject<string>();
  message$ = this.messageSource.asObservable();
  loggedUser: any;

  constructor(
    public http: HttpClient,
    private _storage: Storage,
    public translate: TranslateService,
  ) {
    this.init();
    this.getDados().then(res => {
      if (res) {
        this.loggedUser = res;
        this.idInstituicao = res.instituicao.id;
        this.atualizarDadosPessoa().subscribe(() => { });
      }
    });
  }

  sendMessage(message: string) {
    this.messageSource.next(message);
  }

  async init() {
    const storage = await this._storage.create();
    this._storage = storage;
  }

  getPrivacidade(idInstituicao: any) {
    return this.http.get<any>(this.baseUrl + '/privacidade', { params: { idInstituicao: idInstituicao } }).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  getTermoUso(idInstituicao: any) {
    return this.http.get<any>(this.baseUrl + '/privacidade/termo-uso', { params: { idInstituicao: idInstituicao } }).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  async getMaskCpf(): Promise<any> {
    const config = await this._storage.get('config');
    return config ? config.mask_cpf : null;
  }

  getDados(): Promise<any> {
    return this._storage.get('usuario');
  }

  getDadosInstituicao(): Promise<any> {
    return this._storage.get('instituicao');
  }


  getVersion() {
    return this._storage.get('version');
  }

  hasFacebook() {
    return this.http.get<any>(this.baseUrl + '/pessoa/has-facebook')
      .pipe(map(data => {
        return !data.error ? data : false;
      }));
  }

  getInstituicaoByToken(token: any) {
    return this.http.get<any>(this.baseUrl + '/cadastro/instituicao-by-token', { params: { t: token } })
      .pipe(map(data => {
        return !data.error ? data : false;
      }));
  }

  hasFacebookByKey(key: any) {
    return this.http.post<any>(this.baseUrl + '/cadastro/has-facebook-by-id', { key: key })
      .pipe(map(data => {
        return !data.error ? data : false;
      }));
  }

  desvincularFacebook() {
    return this.http.get<any>(this.baseUrl + '/pessoa/desvincular-facebook')
      .pipe(map(data => {
        return !data.error ? data : false;
      }));
  }

  vincularFacebook(facebook: any) {
    return this.http.post<any>(this.baseUrl + '/pessoa/vincular-facebook', facebook)
      .pipe(map(data => {
        return data;
      }));
  }

  getIdioma() {
    return this._storage.get('idioma').then(data => {
      if (!data) {
        this.translate.setDefaultLang(this.linguagem);
        this.setIdioma(this.linguagem);
      } else {
        this.translate.setDefaultLang(data);
        this.setIdioma(data);
      }
    });
  }

  setIdioma(idioma: string) {
    this._storage.set('idioma', idioma);
    this.linguagem = idioma;
    this.translate.setDefaultLang(idioma);
    return true;
  }

  getPrimeiroAcesso() {
    return this._storage.get('acesso');
  }

  setPrimeiroAcesso(acesso: any) {
    this._storage.set('acesso', acesso);
    return true;
  }

  setTokenPush(pushToken: any, pushTokenType: any, version: any, idInstituicao: any) {
    return this.http.post<any>(this.baseUrl + '/pessoa/push-notification',
      { pushToken: pushToken, pushTokenType: pushTokenType, pushPlatformVersion: '10.3', appVersion: version, idInstituicao: idInstituicao })
      .pipe(map(data => {
        if (!data.error) {
          this._storage.set('tokenpush', pushToken);
          return data;
        } else {
          return false;
        }
      }));
  }

  setVersion(version: any) {
    this._storage.set('version', version);
    return true;
  }

  getUserByToken(token: string) {
    return this.http.post<any>(this.baseUrl + '/login/get-user-by-token', { 'token': token })
      .pipe(map(data => {
        return !data.error ? data : false;
      }));
  }

  /**
   * Realiza o cadastro através do token
  */
  public loginByToken(token: string) {
    return this.http.post<any>(this.baseUrl + '/login/user-by-token', {
      'token': token
    }).pipe(map(data => {
      if (!data.error) {
        let user = data.user;
        user.instituicao = data.instituicao;
        user.config = data.config;
        this._storage.set('token', data.user.apiKey);
        this._storage.set('instituicao', data.instituicao);
        this._storage.set('config', data.config);
        this._storage.set('usuario', user);
        this.loggedUser = user;
        this.http.get('assets/info/info.json').pipe(map(res => <any>res)).subscribe(data => {
          this.getVersion().then(v => {
            if (!v) {
              this.setVersion(data.version);
            }
          });
        });
      }
      return data;
    }));
  }

  getToken() {
    return this.loggedUser ? this.loggedUser.apiKey : null;
  }

  getTokenInstituicao() {
    return this.loggedUser.instituicao.apiToken;
  }

  validaSenha(usuario: {}) {
    return this.http.post<any>(
      this.baseUrl + '/pessoa/valida-senha', usuario, { observe: 'response' }
    ).pipe(map(data => {
      if (!data.body.error) {
        let user = data.body.user;
        this._storage.set('user', data.body.user);
        this._storage.set('usuario', user);
      }
      return data.body;
    }));
  }

  getTokenPush() {
    return this._storage.get('tokenpush');
  }

  public login(usuario: { usuario?: any; senha?: any; instituicao?: any; }) {
    return this.http.post<any>(this.baseUrl + '/login/user', usuario, { observe: 'response' })
      .pipe(
        mergeMap(data => {
          if (!data.body.error) {
            let user = data.body.user;
            this.loggedUser = user;
            user.instituicao = data.body.instituicao;
            user.config = data.body.config;

            return from(Promise.all([
              this._storage.set('token', data.body.user.apiKey),
              this._storage.set('user', data.body.user),
              this._storage.set('instituicao', data.body.instituicao),
              this._storage.set('config', data.body.config),
              this._storage.set('usuario', user),
              this._storage.set('inativa', data.body.status)
            ])).pipe(map(() => data.body));
          }
          return of(data.body);
        })
      );
  }


  public logout() {
    return new Promise((resolve, reject) => {
      this._storage.remove('token').then(d => {
        this._storage.remove('tokenpush');
        this._storage.remove('user');
        this._storage.remove('instituicao');
        this._storage.remove('config');
        this._storage.remove('usuario');
      });
      resolve(true);
    });
  }

  public hasConfig(conf: string | number) {
    if (this.loggedUser && this.loggedUser.instituicao.configPortalAplicativo[conf])
      return true;
    return false;
  }

  public hasPermissao(perm: string) {
    if (this.loggedUser && this.loggedUser.perm[perm])
      return true;

    return false;
  }

  public isLider() {
    if (this.loggedUser)
      return this.loggedUser.lider;
    return false;
  }

  public isAdmOracao() {
    if (this.loggedUser)
      return this.loggedUser.admOracao;
    return false;
  }

  public isAdmEscala() {
    if (this.loggedUser)
      return this.loggedUser.admEscala;
    return false;
  }


  public hasBiblia() {
    if (this.loggedUser && this.loggedUser.instituicao.biblia && this.loggedUser.instituicao.biblia.apiKey)
      return this.loggedUser.instituicao.biblia.apiKey;

    return false;
  }

  public isAnonimo() {
    if (this.loggedUser) {
      return this.loggedUser.isAnonimo;
    }
    return false;
  }

  public isLoggedin() {
    return this.getDados().then(res => {
      if (res) {
        return true;
      } else {
        return false;
      }
    });
  }

  public validarCodigoIgreja(codigo: any) {
    return this.http.post<any>(this.baseUrl + '/cadastro/valida-codigo', { codigo: codigo })
      .pipe(map(data => {
        return !data.error ? data : false;
      }));
  }

  public alterarSenha(senhaatual: any, senha: any) {
    return this.http.post<any>(this.baseUrl + '/cadastro/alterar-senha', { senhaatual: senhaatual, senha: senha, login: this.loggedUser.login })
      .pipe(map(data => {
        return data;
      }));
  }

  public hasAceite(token: string) {
    return this.http.post<any>(this.baseUrl + '/pessoa/has-aceite', { token: token })
      .pipe(map(data => {
        return data;
      }));
  }

  public getAceiteDescricao() {
    return this.http.get<any>(this.baseUrl + '/pessoa/get-aceite-descricao-novo')
      .pipe(map(data => {
        return data;
      }));
  }

  public realizarAceite(tokenpush: any) {
    return this.http.post<any>(this.baseUrl + '/pessoa/realizar-aceite', { tokenpush: tokenpush })
      .pipe(map(data => {
        return data;
      }));
  }

  public getIgrejasFilhas(idInstituicao: any, filtro: any) {
    return this.http.post<any>(this.baseUrl + '/cadastro/lista-instituicoes', { 'idInstituicao': idInstituicao, 'filtro': filtro })
      .pipe(map(data => {
        return !data.error ? data : false;
      }));
  }

  public cadastrarPessoa(pessoa: any) {
    return this.http.post<any>(this.baseUrl + '/cadastro/cadastrar', pessoa)
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return data;
        }
      }));
  }

  public tipoSugerido(idInstituicao: any) {
    return this.http.post<any>(this.baseUrl + '/cadastro/lista-tipo-sugerido', { idInstituicao: idInstituicao })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return data;
        }
      }));
  }

  public contribuicoes() {
    return this.http.get<any>(this.baseUrl + '/pessoa/contribuicoes')
    .pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return data;
      }
    }));
  }

  public contribuicoesDetalhes(idPessoa: any, idPlanoContas: any) {
    return this.http.post<any>(this.baseUrl + '/pessoa/contribuicoes-detalhes',
      { 'idPessoa': idPessoa, 'idPlanoContas': idPlanoContas }
    ).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return data;
      }
    }));
  }

  public esconderCadastro(idInstituicao: any) {
    return this.http.post<any>(this.baseUrl + '/login/esconder-cadastro', { 'idInstituicao': idInstituicao })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return data;
        }
      }));
  }

  public esconderFB(idInstituicao: any) {
    return this.http.post<any>(this.baseUrl + '/login/esconder-cadastrofb', { 'idInstituicao': idInstituicao })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return data;
        }
      }));
  }

  public esconderFBProver() {
    return this.http.post<any>(this.baseUrl + '/login/fb-prover', {})
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return data;
        }
      }));
  }

  public atualizarDadosPessoa() {
    return this.http.get<any>(this.baseUrl + '/pessoa', {
      params: { version: environment.APP_VERSION }
    })
      .pipe(map(data => {
        if (!data.error) {
          let user = data.user;
          this.loggedUser = user;
          user.instituicao = data.instituicao;
          user.config = data.config;
          this._storage.set('config', data.config);
          this._storage.set('instituicao', data.instituicao);
          this._storage.set('usuario', user);
          this._storage.set('inativa', data.status);
          return data;
        } else {
          return false;
        }
      }));
  }

  getTermoConfidencialidade() {
    return this.http.get<any>(this.baseUrl + '/pessoa/get-termo-confidencialidade').pipe(map(data => {
      if (!data.erro) {
        return data;
      } else {
        return false;
      }
    }));
  }

  public registrarAceite(tokenpush: string) {
    return this.http.post<any>(this.baseUrl + '/pessoa/registrar-aceite', { tokenpush: tokenpush })
      .pipe(map(data => {
        return data;
      }));
  }

  getConfigAutoCadastro(idInstituicao: any) {
    return this.http.get<any>(this.baseUrl + '/auto-cadastro/get-config-auto-cadastro', { params: { idInstituicao: idInstituicao } }).pipe(map(data => {
      return data;
    }));
  }
}
